<template>
    <div class="reply" :id="reply.id">
        <v-layout class="reply_layout_unitTest" row wrap v-if="replyStatus">
            <post-owner :can-edit-all-activity-feed="canEditAllActivityFeed" :post="reply" :actions="replyActions" :is-admin-page-post="isAdminPageReply"></post-owner>
            <v-flex xs12>
                <div class="reply__body" v-if="reply.body" id="txt_reply">
                    <span id="txt_reply_body" v-html="replyMessage" data-qe-id="reply_message-body"></span>
                    <span v-if="isShowReplySeeMore" >
                        <a id="btn_see_more" @click="seeMoreReply()" data-qe-id="reply_see-more_link">
                            {{appCommonConstants.SEE_MORE}}
                        </a>
                    </span>
                </div>
            </v-flex>
            <v-flex xs12>

            </v-flex>
            <v-flex xs12 v-if="!isAdminPageReply">
                <span :class="['reply__button', canEditAllActivityFeed ? '' : 'disable_div']"
                      id="reply_like_btn"
                      data-qe-id="reply_like_link"
                      @click="handleReplyLike">
                <img id="img_like_reply" class="like-image" v-if="reply.userHasLiked" src="../../../assets/thumbs-up.png"/>
                <img id="img_dislike_reply" class="like-image" v-if="!reply.userHasLiked" src="../../../assets/thumbs-down.png"/>
                <span class="reply__label-Likes">{{communityCommonConstant.comment.LIKE}}</span>
                </span>
                <span class="reply__likesStatement" data-qe-id="reply_likes_statement">{{likesForTheReply}}</span>
            </v-flex>
        </v-layout>
    </div>
</template>

<script>
    import PostOwner from '../PostOwner/PostOwner';
    import { communityCommonConstant, likeStatement, commentStatement, replyActions } from '../communityCommon.constant';
    import { mapActions } from 'vuex';
    import { storeAction } from '../../../store/storeActions.constant';
    import { appCommonConstants } from "../../appCommon.constants";
    import { trackActivityPostData } from "@/plugins/analytics";
    import { gtmEventName } from "@/plugins/gtmAnalytics";

    export default {
        name: 'Reply',
        components: {
            PostOwner,
        },
        data: () => ({
            communityCommonConstant,
            appCommonConstants,
            replyActions,
            isShowReplySeeMore: false,
            replyMessage: '',
        }),
        props: {
            reply: {
                type: Object,
                required: true,
            },
            canEditAllActivityFeed: {
                type: Boolean,
                default: true,
            },
            isAdminPageReply: {
                type: Boolean,
                default: false,
            },
        },
        methods: {
            ...mapActions({
                sendLike: `chapter/${storeAction.sendLike}`,
                sendUnlike: `chapter/${storeAction.sendUnlike}`,
            }),

            handleReplyLike() {
                if (this.reply.userHasLiked) {
                    this.sendUnlike(this.reply.id);
                    return true;
                }
                if (!this.reply.userHasLiked) {
                    this.sendLike(this.reply.id);
                  trackActivityPostData(gtmEventName.C_Post_Like, this.reply);
                  return true;
                }
            },

            postActivityReply() {
                const dots = "...";
                this.replyMessage = this.reply.body;
                if (this.reply.body.length > 100) {
                    this.replyMessage = this.reply.body.substring(0, 100) + dots;
                    this.isShowReplySeeMore = true;
                }
                this.replyMessage = this.replyMessage.replace(/↵/g, '\n').replace(/\n/g, "<br/>");
            },
            seeMoreReply() {
                this.replyMessage = this.reply && this.reply.body ? this.reply.body.replace(/↵/g, '\n').replace(/\n/g, "<br/>") : '';
                this.isShowReplySeeMore = false;
            },
        },
        computed: {
            likesForTheReply() {
                return likeStatement(this.reply);
            },
            commentForThePost() {
                return commentStatement(this.activity);
            },
            replyStatus() {
                return (!this.isAdminPageReply && !this.reply.hasBeenMarkedInappropriate) ||
                    (this.isAdminPageReply && this.reply.hasBeenMarkedInappropriate);
            },
        },
        created() {
            this.postActivityReply();
        },
    };
</script>

<style lang="scss" scoped>
    @import '../../../common/styles/_colors.scss';
    @import '../../../common/styles/_responsive.scss';

    .reply {
        .disable_div {
            pointer-events: none;
            opacity: 0.5;
        }
        margin: 10px 0 0 55px;

        @include breakpoint(xs) {
            margin: 10px 0 0 20px;

            &__likesStatement {
                margin-left: 30px !important;
            }
        }

        &__body {
            font-size: 12px;
            color: $ypo-gray-text;
            margin: 5px 0 15px 78px;
            word-break: break-word;
        }

        &__button {
            color: rgba($black, 0.8);
            font-size: 12px;
            margin-left: 83px;

            &:hover {
                color: $ypo-gray;
                cursor: pointer;
            }
        }

        &__likesStatement {
            margin-left: 50px;
            color: $ypo-blue;
            font-size: 12px;
        }

        &__label-Likes {
            padding-left: 3px;
        }
    }

    .like-image {
        margin-bottom: -1px;
    }
</style>
